import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { tablerArrowLeft } from '@ng-icons/tabler-icons';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'oc-header',
  standalone: true,
  imports: [CommonModule, NgIconComponent, RouterModule],
  providers: [
    provideIcons({
      tablerArrowLeft,
    }),
  ],
  template: `<div class="page-heading">
    <div class="d-flex gap-2">
      <a *ngIf="backLink" [routerLink]="backLink"><ng-icon name="tablerArrowLeft" color="#fff" size="36"></ng-icon></a>
      <h2 class="page-header">{{ headerTitle }}</h2>
    </div>
    <div><ng-content></ng-content></div>
  </div>`,
  styles: `
    .page-heading {
      padding-bottom: 0.8rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1rem;

      a {
        font-size: 0;
        cursor: pointer;
      }

      h2 {
        margin: 0;
        min-height: 38px;
      }
    }
  `,
})
export class HeaderComponent {
  @Input() headerTitle = '';
  @Input() backLink: any = null;
}
